const LAST_UPDATED = "February 2026";

export default function Terms() {
  return (
    <div className="min-h-screen bg-zinc-950 text-zinc-100" data-testid="terms-page">
      <div className="mx-auto max-w-3xl px-6 py-12">
        <p className="mb-1 text-xs uppercase tracking-[0.25em] text-zinc-500">Legal</p>
        <h1 className="text-3xl font-semibold tracking-tight sm:text-4xl">
          TrueBeliever Auto-Clipper — <span className="text-amber-400">Terms of Service</span>
        </h1>
        <p className="mt-2 text-xs text-zinc-500">Last updated: {LAST_UPDATED}</p>

        <div className="prose mt-10 space-y-6 text-sm leading-relaxed text-zinc-300">
          <section>
            <h2 className="mb-2 text-base font-semibold text-zinc-100">1. About this tool</h2>
            <p>
              TrueBeliever Auto-Clipper is a private internal tool used by
              <strong className="text-zinc-100"> True Believer Non-Denominational Body of Christ</strong> (a
              church) to schedule and publish the church's own sermon clips to the church's own
              YouTube channel, Facebook Page, Instagram (Business) account, and TikTok account.
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-base font-semibold text-zinc-100">2. Who can use it</h2>
            <p>
              This tool is <strong className="text-zinc-100">not offered to the general public</strong>. It is
              operated solely by, and on behalf of, the authenticated church account owner. There is no
              public sign-up, no end-user account creation, and no third-party usage.
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-base font-semibold text-zinc-100">3. What the tool does on your behalf</h2>
            <p>
              When you connect a social platform via OAuth, the tool acts strictly on behalf of the
              authenticated church account owner: it reads source clips from Restream, generates
              caption + hashtag suggestions with AI, and (when enabled) publishes the clips to the
              church's own connected accounts. It never posts to any account other than the one whose
              owner explicitly authorized the connection.
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-base font-semibold text-zinc-100">4. Data retained</h2>
            <ul className="ml-5 list-disc space-y-1">
              <li>OAuth access and refresh tokens for connected platforms, encrypted at rest.</li>
              <li>Clip metadata (titles, transcripts, thumbnails) fetched from Restream.</li>
              <li>Post history (which clip went to which platform and when), for de-duplication.</li>
              <li>Operational error logs for debugging.</li>
            </ul>
          </section>

          <section>
            <h2 className="mb-2 text-base font-semibold text-zinc-100">5. Disconnecting</h2>
            <p>
              You may disconnect any connected platform at any time from the dashboard. Disconnecting
              deletes the stored tokens for that platform from our database.
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-base font-semibold text-zinc-100">6. Contact</h2>
            <p>
              For any questions about these terms, write to{" "}
              <a className="text-amber-300 underline" href="mailto:4thefam@truebelieverfam.com">
                4thefam@truebelieverfam.com
              </a>
              .
            </p>
          </section>
        </div>

        <footer className="mt-12 border-t border-zinc-900 pt-6 text-xs text-zinc-600">
          <a href="/" className="hover:text-zinc-400">← Back to dashboard</a> · <a href="/privacy" className="hover:text-zinc-400">Privacy Policy</a>
        </footer>
      </div>
    </div>
  );
}
